/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{defaultHighlightName as t}from"./HighlightDefaults.js";function r(r){return r?.name??t}export{r as getHighlightName};
